import React from "react";
import { CAREERS, IMAGES } from "./hcaData";
import { HcaReveal, HcaEyebrow } from "./HcaReveal";

export const HcaCareers = () => (
    <section data-testid="hca-careers-section" className="bg-[#0E1E3A] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28">
            <div className="grid lg:grid-cols-12 gap-10 items-end">
                <HcaReveal className="lg:col-span-7">
                    <HcaEyebrow>Where you'll work</HcaEyebrow>
                    <h2 className="font-display text-3xl sm:text-4xl mt-3 leading-tight">
                        Graduate ready for every corner of BC's care system.
                    </h2>
                </HcaReveal>
                <HcaReveal delay={0.1} className="lg:col-span-5 text-white/70 leading-relaxed">
                    HCAs promote the health, safety, independence and comfort of clients and their families, working
                    as part of an interdisciplinary team under the direction of regulated health professionals.
                </HcaReveal>
            </div>
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden">
                {CAREERS.map(([t, d], i) => (
                    <HcaReveal key={t} delay={i * 0.05} className="bg-[#0E1E3A] p-7 hover:bg-[#13284d] transition-colors duration-300">
                        <span className="font-mono text-xs text-[#D4A140]">0{i + 1}</span>
                        <h3 className="font-display text-xl mt-3" data-testid={`hca-career-${i}`}>{t}</h3>
                        <p className="text-sm text-white/60 mt-2">{d}</p>
                    </HcaReveal>
                ))}
            </div>
            <div className="mt-6 grid grid-cols-2 gap-6">
                <img src={IMAGES.clinical} alt="Health care assistant with a patient" className="rounded-2xl aspect-[16/9] w-full object-cover" />
                <img src={IMAGES.community} alt="Caregiver with a senior client" className="rounded-2xl aspect-[16/9] w-full object-cover" />
            </div>
        </div>
    </section>
);
